import Axios from 'axios'
import store from '../store/index.js'
import ui from './ui'

const _axios = {
  Get: (controller, id, showLoading = true) => {
    if (showLoading) { BeforeRequestLoading(this) }
    if (id) {
      return Axios.get(
        process.env.NODE_APP_API + controller + '/' + id
      ).then(HandleResponse, HandleError)
    } else {
      return Axios.get(
        process.env.NODE_APP_API + controller
      ).then(HandleResponse, HandleError)
    }
  },
  GetFile: (controller, id, showLoading = true) => {
    if (showLoading) { BeforeRequestLoading(this) }
    if (id) {
      return Axios.get(
        process.env.NODE_APP_API + controller + '/' + id,
        { responseType: 'arraybuffer' }
      ).then(HandleResponse, HandleError)
    } else {
      return Axios.get(
        process.env.NODE_APP_API + controller,
        { responseType: 'arraybuffer' }
      ).then(HandleResponse, HandleError)
    }
  },
  GetAll: (controller, dto, showLoading = true) => {
    if (showLoading) { BeforeRequestLoading(this) }
    return Axios.get(process.env.NODE_APP_API + controller, {
      params: { request: dto }
    }).then(HandleResponse, HandleError)
  },
  GetBlob: (controller, dto, showLoading = true) => {
    if (showLoading) { BeforeRequestLoading(this) }
    return Axios.get(process.env.NODE_APP_API + controller, {
      params: { request: dto },
      responseType: 'blob' // Force to receive data in a Blob Format
    }).then(HandleResponse, HandleError)
  },
  Post: (controller, dto, showLoading = true) => {
    if (showLoading) { BeforeRequestLoading(this) }
    return Axios.post(process.env.NODE_APP_API + controller, dto).then(
      HandleResponse,
      HandleError
    )
  },
  PostForm: (controller, dto, showLoading = true) => {
    if (showLoading) { BeforeRequestLoading(this) }
    return Axios.post(process.env.NODE_APP_API + controller, dto, { headers: { 'Content-Type': 'multipart/form-data' } }).then(
      HandleResponse,
      HandleError
    )
  },
  Put: (controller, id, dto, showLoading = true) => {
    if (showLoading) { BeforeRequestLoading(this) }
    if (!dto) {
      dto = {}
    }
    return Axios.put(
      process.env.NODE_APP_API + controller + '/' + id,
      dto
    ).then(HandleResponse, HandleError)
  },
  Delete: (controller, id, showLoading = true) => {
    if (showLoading) { BeforeRequestLoading(this) }
    return Axios.delete(process.env.NODE_APP_API + controller + '/' + id)
      .then(HandleResponse, HandleError)
  },
  GetParams: (controller, paramns, showLoading = true) => {
    if (showLoading) { BeforeRequestLoading(this) }
    if (!paramns) { paramns = {} }
    return Axios.get(process.env.NODE_APP_API + controller, { params: paramns })
      .then(HandleResponse, HandleError)
  }
}

const BeforeRequestLoading = (evt) => {
  store.commit('incrementRequests')
}

const HandleResponse = (response) => {
  // ui.ShowSuccess()
  store.commit('decrementRequests')
  return response.data
}

const HandleError = (error) => {
  store.commit('decrementRequests')
  if (error) {
    if (error.response.status === 401) {
      window.location.href = '/login'
    }
    if (error.response) {
      if (error.response.status === 403) { ui.ShowAlert('Erro', 'Usúario não possui permissão para essa operação.') } else if (error.response.status === 401) {
        ui.ShowAlert('Erro', 'Usúario não autenticado.')
      } else if (error.response.data.errors) {
        ui.ShowAlert('Erro', Object.values(error.response.data.errors)[0][0])
      } else {
        if (error.response.data.includes('1085') || error.response.data.includes('1100') || error.response.data.includes('1101') || error.response.data.includes('1102')) {
          ui.ShowAlert('', error.response.data)
        } else {
          ui.ShowError('Erro', error.response.data)
        }
      }
      return {
        error: error.response.data
      }
    } else {
      ui.ShowError('Erro', error)
      return { error: error }
    }
  }
}

export default {
  Axios: _axios
}



// WEBPACK FOOTER //
// ./src/_api/util.js